<template>
    <div>
        <div class="active" v-show="'projectdesk-project' == currentStep.key">
            <div class="form-group">
                <label for=""> Project Name</label>
                <input type="text" class="form-control" name="name" required>
            </div>
            <div class="form-group">
                <label for=""> Channel</label>
                <select class="form-control" name="id_channel">
                    <option value="">Select a channel</option>
                    <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for=""> Priority</label>
                <select class="form-control" name="priority">
                    <option value="">Select priority</option>
                    <option value="1">High</option>
                    <option value="2">Normal</option>
                    <option value="3">Low</option>
                </select>
            </div>
            <div class="form-group">
                <label for=""> Project Description</label>
                <textarea class="form-control" rows="3" name="description"></textarea>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for=""> Start Date</label>
                        <input type="text" class="form-control" name="start_date" required>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for=""> End Date</label>
                        <input type="text" class="form-control" name="end_date" required>
                    </div>
                </div>
            </div>

        </div>
        <div class="active" v-show="'projectdesk-contributors' == currentStep.key">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="users-list-w">
                            <div class="user-w with-status status-green">
                                <div class="user-avatar-w">
                                    <div class="user-avatar"><img alt="" :src="user.avatar"></div>
                                </div>
                                <div class="user-name">
                                    <h6 class="user-title">{{user.name}}</h6>
                                    <div class="user-role">You are the owner for this project</div>
                                </div>
                            </div>
                            <div class="user-w with-status status-green" v-for="user in selectedUsers">
                                <div class="user-avatar-w">
                                    <div class="user-avatar"><img alt="" :src="user.avatar"></div>
                                </div>
                                <div class="user-name">
                                    <h6 class="user-title">{{user.name}}</h6>
                                    <div class="user-role">{{user.role_code}}</div>
                                </div>
                                <th class="">
                                    <span class="btn btn-danger btn-sm" @click="removeUser(user)">Remove</span>
                                </th>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="active" v-show="'projectdesk-products' == currentStep.key">
            <div class="form-group">
                <label> Products (One sku per line)</label>
                <textarea class="form-control" rows="10" name="products"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['currentStep', 'channels', 'categories', 'selectedUsers'],
  data () {
    return {
      user: ''
    }
  },
  mounted () {
    this.getUser()
  },
  methods: {
    getUser () {
      this.user = this.$store.getters.authUser
    },
    removeUser (user) {
      this.$emit('headerInterface', user)
    }
  }
}
</script>
